import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { Actions } from "@/store";
import BlogForm from "@/components/blog/BlogForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditBlogPage',
  setup(__props) {

const store = useStore();
const route = useRoute();

onMounted(() => {
  if (route.params.id) {
    store.dispatch(Actions.GetBlog, route.params.id);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BlogForm))
}
}

})